import { SUPERGRAPH_URL_PROD, SUPERGRAPH_URL_STAGE } from '../constants';
import { env } from '../lib/env';
import * as v from 'valibot';

export function nullishToUndefinedable<
  TWrapped extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
  TDefault extends v.Default<TWrapped, null | undefined>,
>(wrapped: TWrapped, defaultValue?: TDefault) {
  return v.optional(
    v.pipe(
      v.nullish(wrapped, defaultValue),
      v.transform(val => (val === null ? undefined : val)),
    ),
  );
}

export const getSupergraphUrl = () => {
  return env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod' ? SUPERGRAPH_URL_PROD : SUPERGRAPH_URL_STAGE;
};
